import { Directive } from '@angular/core';
import { environment } from '@env/environment';
import { IQueryParam } from '@interfaces/fast-report-params';

@Directive({})
export class ResourceUrlHelper {
  protected url: string;
  private readonly apiUrl = environment.apiUrl;
  private readonly token = localStorage.getItem('access_token');

  constructUrl(path: string, queryList?: IQueryParam[]): string {
    const resUrl = new URL(new URL(this.apiUrl).origin);
    resUrl.pathname = path;
    resUrl.searchParams.append('access_token', this.token);
    if (queryList?.length) {
      queryList.forEach((el) => {
        resUrl.searchParams.append(el.parameter, el.value.toString());
      });
    }
    return resUrl.toString();
  }
}
